import "./MarketingVideo.css";
import React from "react";
import ga from "util/gaEventTracker";
import isString from "lodash/isString";
import { observable } from "mobx";
import { observer } from "mobx-react";
import { LoadingSpinner } from "../message/LoadSpinner";
import Modal from "../../../components/common/Modal";
import Propulator from "higher-order/Propulator";
import autobind from "autobind-decorator";

@observer
class MarketingVideo extends React.Component {

    @observable isLoaded = false;

    @autobind
    handleVideoClick(e) {
        this.props.dispatcher.emit("OPEN_MODAL", {
            modalKey: this.props.videoModal.modalKey
        });
    }

    componentDidMount() {
        // Log vimeo events to google analytics.
        const iframe = this.iframe;
        window.addEventListener("message", (e) => {
            if (e.origin !== "https://player.vimeo.com" || !isString(e.data)) {
                return;
            }
            const data = JSON.parse(e.data);
            switch (data.event) {
                case "ready":
                    this.isLoaded = true;
                    if (iframe && iframe.contentWindow) {
                        const request = { method: "addEventListener", value: "play" };
                        iframe.contentWindow.postMessage(JSON.stringify(request), "https://player.vimeo.com");
                    }
                    break;
                case "play":
                    ga("video", "play", this.props.gaName);
                    break;
                default:
                    break;
            }
        });
    }

    render() {
        return (
            <React.Fragment>
                {this.props.renderButton && this.props.renderButton(this.handleVideoClick)}
                {!this.props.renderButton &&
                    <button className="marketing-video-open-button" onClick={this.handleVideoClick}>
                        <img className="button-preview" src={this.props.previewSrc} alt="Play video" />
                        <div className="overlay" />
                        <span className="play-video">
                            <span className="desktop">Play Video</span>
                            <i className="icon-play-circled" />
                        </span>
                    </button>
                }
                <Modal {...this.props.videoModal} className="marketing-video-modal">
                    <div className="marketing-video-container" key={this.props.src}>
                        <iframe title="Gradifi is Gratitude" ref={iframe => { this.iframe = iframe; }} className="marketing-video" src={this.props.src} width="640" height="360" frameBorder="0" allowFullScreen={true} />
                        {!this.isLoaded &&
                            <LoadingSpinner />
                        }
                    </div>
                </Modal>
            </React.Fragment>
        );
    }
}

export default Propulator(MarketingVideo, {});
